import { useState, type JSX } from 'react';
import { NavLink } from 'react-router-dom';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { SwiperClass } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import { getContentImageUrl } from 'utils/app';
import { getContentsTypeStr } from 'utils/content';

/**
 * ホーム画面 作成中コンテンツコンポーネント
 */
export default function WsIndexContentsUnpublished(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);

  const [contentSelectedState, setContentSelectedState] = useState(
    acctState.activeContent?.unpublished[0]
  );

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * スワイパー変更時の処理
   */
  const onSlideChange = (swiper: SwiperClass) => {
    setContentSelectedState(acctState.activeContent?.unpublished[swiper.activeIndex]);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <div className="col-md-4">
        <div className="card card-simple" data-mh="card-simple">
          <div className="card-header">
            <h3 className="title-with-icon title-with-icon-sm mb-0">
              <img src="/img/icon/pen.svg" alt="作成中コンテンツ" className="icon-pen" />
              作成中コンテンツ
            </h3>
          </div>
          <div className="card-body">
            <div className="ws-index-quizzesswiper-container swiper-simple">
              <Swiper modules={[Navigation]} navigation onSlideChange={onSlideChange}>
                {acctState.activeContent?.unpublished.map(quiz => {
                  return (
                    <SwiperSlide key={`ws-index-quizzes-up-swiper-${quiz.id}`}>
                      <div
                        style={{ minHeight: '185px' }}
                        className="d-flex flex-column justify-content-end"
                      >
                        <img
                          src={getContentImageUrl(quiz.imageKey)}
                          className="img-fluid mx-auto d-block"
                          style={{ maxWidth: '185px' }}
                        />
                        <p className="caption text-center">{quiz.title}</p>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
            {/* 編集ボタン */}
            {contentSelectedState && (
              <div className="text-center">
                <NavLink
                  to={`/ws/${acctState.company.cd}/${getContentsTypeStr(
                    contentSelectedState.contentsTypeDiv
                  )}/edit/${contentSelectedState?.cd}`}
                  className="btn btn-outline blue"
                >
                  編集する
                </NavLink>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
